import Filters from "@components/filters";
import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { Button, Col, Drawer, Row, Tooltip } from "antd";
import moment from "moment";
import React, { createRef, FC, Fragment, useEffect, useRef, useState } from "react";
import Consult from "@assets/Consult.svg";
import DentalTooth from "@assets/DentalTooth.svg";

import Call from "@assets/Call.svg";

import "./dayCalenderViewPage.scss";
import { forEach } from "lodash";
import { formatPhoneNumber, formatTimeForReminder  } from "@utils/helpers";

const DayCalenderViewPage: FC<any> = () => {
  const _state = {
    isLoading: true,
    isGraphLoading: false,
    activeSideCard: [],
    sideCardData: [],
    topCardData: [],
    isOpenDrawer: false,
    selectedRowIndex: null,
    isPopOverOpen: false,
    dateChangeFilterApplied: false,
    // tempFiltersData:filterdata,
  };

  const officeTimeScroll = useRef<any>(null);

  const [state, setState] = useState<any>(_state);
  // const [selectedDate, setSelectedDate] = useState(moment());
  const setIsDrillDownViewSelected = useCalenderViewStore((state) => state.setIsDrillDownViewSelected);
  // const setAppointmentPatientSelected = useCalenderViewStore((state) => state.setAppointmentPatientSelected);
  const setSelectedPatientProfile = useCalenderViewStore((state) => state.setSelectedPatientProfile);
  const selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
  const [dayWiseAppointmentDetails, setDayWiseAppointmentDetails] = useState<any>([]);
  const setIsProfileView = useCalenderViewStore((state) => state.setIsProfileView);
  const [loader , setLoader] = useState<boolean>(false);
  const dayFilter = useCalenderViewStore((state) => state.dayFilter);
  const officeId = useCalenderViewStore((state) => state.officeId);
  const applyFilterFlag = useCalenderViewStore((state) => state.applyFilterFlag);
  const [dayRowWidth, setdayRowWidth] = useState<string>("100%")

  useEffect(() => {
    console.log("DayCalenderViewPage.useEffect1");
    let appointmentDayDetails: any[] = [];
    let noOfOperators = 0;
    setLoader(true);
    let filters: { filterType: string; filterValues: any; }[] = [];

    forEach(Object.keys(dayFilter), (filterData)=>{
      if(dayFilter[filterData].length>0){
          filters.push({
              filterType:filterData,
              filterValues:dayFilter[filterData]
            })
      }
    })
  let officeID = officeId;
    dashboardService.fetchCalenderDayViewAppointments(selectedDateCalender.format("YYYY-MM-DD"), officeID, filters).subscribe({
      next: (v) => {
        // console.log(v.data.data.result);
        appointmentDayDetails = v.data.data.result;
        setDayWiseAppointmentDetails(appointmentDayDetails);
        for(let i = 0 ; i < appointmentDayDetails.length ; i++){
          noOfOperators = noOfOperators + appointmentDayDetails[i].operatoryDetails.length
        }
        if(noOfOperators >=7){
          setdayRowWidth(`${(noOfOperators * 14.5)+appointmentDayDetails.length}rem`);
        }
        else{
          setdayRowWidth("100%");
        }
        setLoader(false);
        

        if (officeTimeScroll.current === null) { }
        else {
          officeTimeScroll!.current!.scrollIntoView({ block: 'end', behavior: 'smooth', inline: 'end' });
        }
        // window.scrollTo(0, document.body.scrollHeight);
        
      },

      error: (e) => {
        console.log(e);
        setLoader(false);
      },
    });
  }, [selectedDateCalender, applyFilterFlag, dayFilter, officeId]);


  const [currentDayTimeLine, setCurrentDayTimeLine] = useState(moment());
  useEffect(()=>{
    console.log("DayCalenderViewPage.useEffect2");
    setInterval(()=>setCurrentDayTimeLine(moment()), 1000);
  },[]);

  const currentTimeLine = createRef<any>();

  let appointment = [
    {
      careManagerId: "10000019",
      patientId: "671",
      patientName: "Johnson, Wayne",
      reminder: "11 - 1",
      reminderEndDate: "2022-05-05 13:00:00",
      reminderId: "259",
      reminderStartDate: "2022-05-05 11:00:00",
    },
    {
      careManagerId: "10000019",
      patientId: "2730",
      patientName: "Gartland, Barbara",
      reminder: "12:30 - 2:30",
      reminderEndDate: "2022-05-05 14:30:00",
      reminderId: "260",
      reminderStartDate: "2022-05-05 12:30:00",
    },
    {
      careManagerId: "10000019",
      patientId: "3571",
      patientName: "Rivera, Ana",
      reminder: "5:30 - 6:15",
      reminderEndDate: "2022-05-05 18:15:00",
      reminderId: "261",
      reminderStartDate: "2022-05-05 17:30:00",
    },
  ];

  // let operatorListExtraction = appointmentData.map((operator) => {
  //   return {
  //     provider: operator.details[0].provider,
  //     operatorType: operator.details[0].operatorType,
  //   };
  // });

  // const colorCodeForOperator = [
  //   "turquoise",
  //   "deepskyblue",
  //   "salmon",
  //   "orange",
  //   "lightgoldenrodyellow",
  //   "peachpuff",
  //   "palegreen",
  //   "yellowgreen",
  //   "lightsalmon",
  //   "turquoise",
  //   "lightseagreen",
  //   "plum",
  //   "mediumpurple",
  //   "lightpink",
  //   "burlywood",
  //   "silver",
  //   "navajowhite",
  // ];

  // const changeSelectedDate = (add: boolean) => {
  //   const copyDate = moment(selectedDate);
  //   setSelectedDate(add ? copyDate.add(1, "d") : copyDate.subtract(1, "d"));
  // };

  const tooltip = (data : any , name?: any , type?: any , id?: any , startTime?: any , endTime?: any) => {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500" }}>
          <div style={{ fontSize: "12" }}>{data.patientName} &nbsp; </div>
          <div>$ {data.cost.toLocaleString()}</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ fontSize: "10px" }}>
            <img src={Call} alt="" height="10px" />
          </div>
          <div style={{ marginLeft: "3px" }}>{formatPhoneNumber(data.phoneNo , "usFormat") || "NA"}</div>
        </div>
        <div style={{ display: "flex", width: "10rem", flexWrap: "wrap" }}>
        <span className="summary-icon"><span className="icon"><img className="dentalToothIcon" src={DentalTooth} alt="" /></span></span>
          {data.diagnosisCodes ? data.diagnosisCodes?.split("/").map((patientDiagnosis: any, index: any) => {
            return (
              <div key={index+1024} style={{ marginRight: "3px" }}>
                {patientDiagnosis}
              </div>
            );
          }) : "NA"}
        </div>
        <div style={{ display: "flex" }}>
          <div>
            <img src={Consult} alt="" />
          </div>
          <div style={{ marginLeft: "3px" }}>{data.appointmentNotes || "NA"}</div>
        </div>
        <div>Provider Name : {name}</div>
        <div>Provider Type : {type}</div>
        <div>Operatory ID : {id}</div>
        <div>Appointment Start Time : {formatTimeForReminder(startTime)}</div>
        <div>Appointment end Time : {formatTimeForReminder(endTime)}</div>
      </div>
    );
  }

  const calenderStartTime = 0;
  const calenderEndTime = 23;

  const getTimeline = () => {
    let arr = [];
    for (let index = calenderStartTime; index <= calenderEndTime; index++) {
      arr.push(index === 12 ? "12 PM" : index > 12 ? `${index - 12} PM` : `${index} AM`);
    }
    return arr;
  };

  const getStartPosition = (from: any) => {
    if (from === "") {
      return -96;
    } else {
      const date = moment(from);
      const hr = date.hour();
      const min = date.minute();
      return hr * 60 + min;
    }
  };

  const getDuration = (from: any, to: any) => {
    const fromDate = moment(from);
    const toDate = moment(to);
    return toDate.diff(fromDate, "minutes");
  };

  const getWidth = (from: any) => {
    let count = [...appointment].filter((rem: any) => {
      return moment(from).valueOf() === moment(rem.reminderStartDate).valueOf();
    }).length;
    return count > 0 ? 100 / count : 100;
  };

  // const getWidthForColumnBorder = () => {
  //   let count = appointmentData.length;
  //   if (count <= 5) {
  //     let colMargin = (100 / count).toFixed(0);
  //     return colMargin + "%";
  //   } else {
  //     return "16rem";
  //   }
  // };

  // const getWidthForAppointment = () => {
  //   let count = appointmentData.length;
  //   if (count <= 5) {
  //     let colMargin = (100 / count).toFixed(0);
  //     let appontmentWidth = parseInt(colMargin) - 5;
  //     return appontmentWidth + "vw";
  //   } else {
  //     return "15rem";
  //   }
  // };

  const getLeft = (from: any, reminderId: any) => {
    const w = getWidth(from);
    const overlappedRem = [...appointment].filter((rem: any) => {
      return moment(from).valueOf() === moment(rem.reminderStartDate).valueOf();
    });
    return w === 100 ? 0 : w * overlappedRem.findIndex((rem) => rem.reminderId === reminderId);
  };

  ////////////////////////////////////////////////////////////////////Filter

  const applySideFilters = (startDate: any | undefined, endDate: any | undefined, comingFromDateChange: boolean | undefined) => {
    console.log("filter applied");
  };

  //////////////////////////////////////////////////////////////////Clear Filter
  const clearFilterHandler = () => {
    console.log("filters cleared");
  };

  /////////////////////////////////////////////////////////////////Filter change handler

  const filtersChangeHandler = (category: string, selectedArray: any) => {
    console.log("filter opened");
  };

  /////////////////////////////////////////////////////////////////DrillDownView For Day calender

  const popDrillDownViewForDayCalender = (appointmentPatientID: string) => {
    console.log("popDrillDownFor day calender");
    setIsDrillDownViewSelected(true);
    setIsProfileView(true);
    // setAppointmentPatientSelected(appointment);
    setSelectedPatientProfile(appointmentPatientID);
  };

  let firstColumn = true;
  let innerColumnFlag = true;

  const getTimeOfTheDay = (appointmentStartTime: string) => {
    let dateO = selectedDateCalender.format("YYYY-MM-DD");
    let exa = moment(`${dateO} ${appointmentStartTime}`).format("YYYY-MM-DD HH:mm:ss");
    return exa;
  };

  const getAppointmentEndTime = (appointmentStartTime: string, appointmentDuration: string) => {
    let check = getTimeOfTheDay(appointmentStartTime);
    return moment(check).add(parseInt(appointmentDuration), "minutes").format("YYYY-MM-DD HH:mm:ss");
  };

  const getAppointmentBodyColor = ({index = 0 , opacity = 1 }) => {
    const appointmentBodyColors = [
     `rgba(33, 145, 182 , ${opacity})`,
     `rgba(15, 10, 222, ${opacity})`,
     `rgba(241, 90, 34, ${opacity})`,
     `rgba(20, 205, 200, ${opacity})`,
     `rgba(150, 54, 148, ${opacity})`,
     `rgba(37, 41, 88, ${opacity})`,
     `rgba(132, 140, 207, ${opacity})`,
     `rgba(8, 14, 44, ${opacity})`,
     `rgba(101,198,187, ${opacity})`,
     `rgba(246,36,89, ${opacity})`,
     `rgba(110,48,75, ${opacity})`,
     `rgba(206,195,200, ${opacity})`,
     `rgba(11, 127, 171, ${opacity})`,
     `rgba(46,204,113, ${opacity})`,
     `rgba(200,247,297, ${opacity})`,
     `rgba(0,230,64, ${opacity})`,
     `rgba(38,166,91, ${opacity})`,
     `rgba(189,155,25, ${opacity})`,
     `rgba(246,36,89, ${opacity})`,
     `rgba(190,86,131, ${opacity})`,

    ]
    return appointmentBodyColors[index]
  }

  return (
    <>
      <div className="ui-calenderView">
        <div className="ui-calenderView__dayCalender-container">
          {/* <div className="ui-calenderView__dayCalender-container__header">
                            {operatorListExtraction.map((operator,index) => {
                                return (
                                    <div className="ui-calenderView__dayCalender-container__header__card">
                                        <div className="ui-calenderView__dayCalender-container__header__card__icon" style={{backgroundColor:`${colorCodeForOperator[index]}`, color:"white"}}>
                                            {operator.provider.slice(0, 2).toUpperCase()}
                                        </div>
                                        <div className="ui-calenderView__dayCalender-container__header__card__body">
                                            <div className="ui-calenderView__dayCalender-container__header__card__body__provider-title">
                                                {operator.operatorType}
                                            </div>
                                            <div className="ui-calenderView__dayCalender-container__header__card__body__provider-name">
                                                {operator.provider}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div> */}
          <div className="ui-calenderView__day-timeline-container custom-scroll-bar">
            <Row style={{width: dayRowWidth}}>
              <Col span={24}>
                <div className="ui-calenderView__day-timeline-container__view">
                  <div className={`ui-calenderView__day-timeline-container__view__gmt-details ${loader ? "h60" : ""}`}  >{/* GMT {moment().local().format("Z")} */}</div>
                  <div className="ui-calenderView__day-timeline-container__view__actual-daytimeline">
                    <table className="ui-calenderView__day-timeline-container__view__actual-daytimeline__timing-table">
                      <tbody>
                        <tr>
                          <td>
                            {getTimeline().map((time, index) => {
                              return <div key={time+index+32}className="ui-calenderView__day-timeline-container__view__actual-daytimeline__timing-table__timing-label">{time === "0 AM" ? "12 AM" : time}{time === "12 PM" ? <span id={'officeTimeScroll'} ref={officeTimeScroll}></span> : null}</div>;
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-table">
                      <tbody>
                        <tr>
                          <td>
                            {getTimeline().map((time, index) => (
                              <>
                                <div
                                  key={time+index+43}
                                  className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-table__appointment-item"
                                  style={{ backgroundColor: `${index === 0 ? "#FFFFFF" : "#F4F5F7"}` }}
                                ></div>
                                <div className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-table__appointment-item-b"></div>
                              </>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container">
                     {loader ? <div style={{height : "100px"}}><Row style={{ display: "flex", width: "100%", flexWrap:"nowrap" ,transform: `translateY(-60px)` }}>{Array.from(Array(6).keys()).map(item => (
                      <Col> 
                      <div  style={{ width: "14rem", marginLeft: "8px" }}>
                                  <div className="operatorName operatorName_preloader shimmerBG"></div>
                                  <div className="operatorType operatorType_preloader shimmerBG"></div>
                                  <div className="operatorId operatorId_preloader shimmerBG"></div>
                                </div>
                    </Col>
                     ))} </Row></div> :
                      <Row style={{ display: "flex", width: "100%", flexWrap:"nowrap" }}>
                        <>
                          {dayWiseAppointmentDetails.map((provider: any, providerIndex: any) => (
                            <Fragment key={providerIndex+47}>                              
                              <Col style={{ zIndex: "11" }}>
                                <div className="col-header-operator" style={{ width: `${firstColumn ? "14rem" : "14.5rem"}`, transform: `translateY(${getStartPosition("")}px)`, marginLeft: `${firstColumn ? "8px" : "0"}` }}>
                                  <div className="operatorName">{provider.providerName}</div>
                                  <div className="operatorType">{provider.providerType}</div>
                                  <div className="operatorId">Operatory ID: {provider.operatoryDetails[0]["Operatory ID"]}</div>
                                </div>
                                {provider.operatoryDetails[0].appointments.map((operatoryAppointments: any, index: any) => {
                                  return (
                                    <Tooltip placement="topLeft" title={tooltip(operatoryAppointments , provider.providerName , provider.providerType , provider.operatoryDetails[0]["Operatory ID"] ,getTimeOfTheDay(operatoryAppointments.appointmentTime), getAppointmentEndTime(operatoryAppointments.appointmentTime, operatoryAppointments.appointmentDuration))}  overlayClassName="table-tooltip">
                                      <div
                                        className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container__appointment-item"
                                        style={{
                                          transform: `translateY(${getStartPosition(getTimeOfTheDay(operatoryAppointments.appointmentTime))}px)`,
                                          height:
                                            getDuration(
                                              getTimeOfTheDay(operatoryAppointments.appointmentTime),
                                              getAppointmentEndTime(operatoryAppointments.appointmentTime, operatoryAppointments.appointmentDuration)
                                            ) - 1,
                                          width: `100%`,
                                          left: `${getLeft("2022-05-05 01:00:00", 1)}%`,
                                        }}
                                        onClick={() => popDrillDownViewForDayCalender(operatoryAppointments.patientId)}
                                        key={operatoryAppointments.patientId + index + 10}
                                      >
                                        <div
                                          className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container__appointment-item__appointment-body"
                                          style={{
                                            background: getAppointmentBodyColor({ index: providerIndex, opacity: 0.2 }),
                                            color: getAppointmentBodyColor({ index: providerIndex }),
                                            width: "14rem",
                                            borderLeft: `3px solid ${getAppointmentBodyColor({ index: providerIndex })}`,
                                          }}
                                        >
                                          <div className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container__appointment-item__appointment-body__appointment-title">
                                            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500" }}>
                                              <div style={{ fontSize: "12" }}>{operatoryAppointments.patientName} &nbsp; </div>
                                              <div>$ {operatoryAppointments.cost.toLocaleString()}</div>
                                            </div>
                                            <div style={{ display: "flex" }}>
                                              <div>
                                                <img src={Call} alt="" height="10px"/>
                                              </div>
                                              <div style={{ marginLeft: "3px" }}>{formatPhoneNumber(operatoryAppointments.phoneNo , "usFormat") || "NA"}</div>
                                            </div>
                                            <div style={{ display: "flex", width: "10rem", flexWrap: "wrap" }}>
                                            <span className="summary-icon"><span className="icon"><img className="dentalToothIcon" src={DentalTooth} alt="" /></span></span>
                                              {operatoryAppointments.diagnosisCodes ? operatoryAppointments.diagnosisCodes?.split("/").map((patientDiagnosis: any, index: any) => {
                                                return (
                                                  <div key={index + 22} style={{ marginRight: "3px" }}>
                                                    {patientDiagnosis}
                                                  </div>
                                                );
                                              }) : "NA"}
                                            </div>
                                            <div style={{ display: "flex" }}>
                                              <div>
                                                <img src={Consult} alt="" />
                                              </div>
                                              <div style={{ marginLeft: "3px" }}>{operatoryAppointments.appointmentNotes || "NA"}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Tooltip>
                                  );
                                })}

                                {(firstColumn = false)}
                                {provider.operatoryDetails.length > 1
                                  ? provider.operatoryDetails.map((operatoryColumn: any,operatoryColumnIndex:any) => {
                                      if (innerColumnFlag) {
                                        innerColumnFlag = false;
                                        return null;
                                      }
                                      return (
                                        <Col key={operatoryColumnIndex + 11} style={{ marginLeft: `${operatoryColumnIndex*14.5}rem`, zIndex: "11" }}>
                                          <div className="col-header-operator" style={{ width: "14.5rem", transform: `translateY(-100px)`, paddingTop: ` ${5-((operatoryColumnIndex-1)*0.05)}rem` }}>
                                            <div className="operatorName"></div>
                                            <div className="operatorType"></div>
                                            <div className="operatorId">Operatory ID: {operatoryColumn["Operatory ID"]}</div>
                                          </div>

                                          {operatoryColumn.appointments.map((secondaryProviderAppointment: any, index:any) => {
                                            return (
                                              <Tooltip placement="topLeft" title={tooltip(secondaryProviderAppointment , provider.providerName , provider.providerType ,operatoryColumn["Operatory ID"] , getTimeOfTheDay(secondaryProviderAppointment.appointmentTime),
                                              getAppointmentEndTime(secondaryProviderAppointment.appointmentTime, secondaryProviderAppointment.appointmentDuration))}  overlayClassName="table-tooltip">
                                                <div
                                                  key={operatoryColumnIndex + index + 91}
                                                  className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container__appointment-item"
                                                  style={{
                                                    transform: `translateY(${getStartPosition(getTimeOfTheDay(secondaryProviderAppointment.appointmentTime))}px)`,
                                                    height:
                                                      getDuration(
                                                        getTimeOfTheDay(secondaryProviderAppointment.appointmentTime),
                                                        getAppointmentEndTime(secondaryProviderAppointment.appointmentTime, secondaryProviderAppointment.appointmentDuration)
                                                      ) - 1,
                                                    width: `100%`,
                                                    left: `${getLeft("2022-05-05 02:00:00", 1)}%`,
                                                    marginLeft: 0,
                                                  }}
                                                  onClick={() => popDrillDownViewForDayCalender(secondaryProviderAppointment.patientId)}
                                                >
                                                  <div
                                                    className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container__appointment-item__appointment-body"
                                                    style={{
                                                      background: getAppointmentBodyColor({ index: providerIndex, opacity: 0.2 }),
                                                      color: getAppointmentBodyColor({ index: providerIndex }),
                                                      width: "14rem",
                                                      borderLeft: `3px solid ${getAppointmentBodyColor({ index: providerIndex })}`,
                                                    }}
                                                  >
                                                    <div className="ui-calenderView__day-timeline-container__view__actual-daytimeline__appointment-container__appointment-item__appointment-body__appointment-title">
                                                      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500" }}>
                                                        <div style={{ fontSize: "12" }}>{secondaryProviderAppointment.patientName} &nbsp; </div>
                                                        <div>$ {secondaryProviderAppointment.cost.toLocaleString()}</div>
                                                      </div>
                                                      <div style={{ display: "flex" }}>
                                                        <div style={{fontSize : "10px"}}>
                                                          <img src={Call} alt="" height="10px"/>
                                                        </div>
                                                        <div style={{ marginLeft: "3px" }}>{formatPhoneNumber(secondaryProviderAppointment.phoneNo , "usFormat")|| "NA"}</div>
                                                      </div>
                                                      <div style={{ display: "flex", width: "10rem", flexWrap: "wrap" }}>
                                                      <span className="summary-icon"><span className="icon"><img className="dentalToothIcon" src={DentalTooth} alt="" /></span></span>
                                                        {secondaryProviderAppointment.diagnosisCodes ? secondaryProviderAppointment.diagnosisCodes?.split("/").map((patientDiagnosis: any, index:any) => {
                                                          return <div key={patientDiagnosis+index+3}>{patientDiagnosis}</div>;
                                                        }) : "NA"}
                                                      </div>
                                                      <div style={{ display: "flex" }}>
                                                        <div>
                                                          <img src={Consult} alt="" />
                                                        </div>
                                                        <div style={{ marginLeft: "3px" }}>{secondaryProviderAppointment.appointmentNotes || "NA"}</div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </Tooltip>
                                            );
                                          })}
                                        </Col>
                                      );
                                    })
                                  : null}
                              </Col>                            
                              <Col className="borderForColumn"></Col>
                              {/* {(firstColumn = true)} */}
                              {innerColumnFlag=true}
                            </Fragment>                          
                          ))}
                        </>
                      </Row>}
                    </div>
                    {selectedDateCalender.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? (
                      <div
                        ref={currentTimeLine}
                        className="ui-calenderView__day-timeline-container__view__actual-daytimeline__current-time-line"
                        style={{ transform: `translateY(${getStartPosition(currentDayTimeLine) - 1}px)`, zIndex: 15 }}
                      ></div>
                    ) : null}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <Drawer
        destroyOnClose={true}
        title={"Filters:"}
        placement="right"
        closable={false}
        onClose={() =>
          setState({
            ...state,
            isOpenDrawer: false,
          })
        }
        visible={state.isOpenDrawer}
        key="right"
        width={300}
        bodyStyle={{ padding: 0 }}
        footer={
          <div style={{ textAlign: "right" }} className="cancel-button">
            <Button
              type="text"
              size="large"
              onClick={() => {
                setState({
                  ...state,
                  isOpenDrawer: false,
                });
              }}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              onClick={(e) => {
                e.stopPropagation();
                applySideFilters(undefined, undefined, undefined);
              }}
              className="apply-filter"
              style={{ height: "40px" }}
            >
              Apply Filter
            </Button>
          </div>
        }
        extra={
          <Button type="link" onClick={clearFilterHandler} className="clr-e100" style={{ fontWeight: "normal" }}>
            Clear All
          </Button>
        }
      >
        <Filters data={state.tempFiltersData} changeHandler={filtersChangeHandler} />
      </Drawer>
    </>
  );
};

export default DayCalenderViewPage;
